import React, { useState } from "react";
import { TitlesTyp } from "../../../../../../components/Typography/Typography";
import {
  AlignmentEnum,
  FontWeightEnum,
} from "../../../../../../types/AppTypes";
import { DoubleStructure } from "../../../../../../components/core/DoubleStructure/DoubleStructure";
import {
  GRADES_PATHS,
  INTERNAL_GRADE_LABEL,
  JOB_FAMILIES,
  SUBGRADES_LABEL,
} from "../../../../../../constants/Dictionary";
import {
  TextSwitch,
  OptionItem,
} from "../../../../../../components/TextSwitch/TextSwitch";
import {
  StyledManagementPage,
  StyledManagementHeader,
} from "../../../../Management.styled";
import { InternalGradePagesEnum } from "../../../../../../constants/AppConstants";
import { ManageJobFamilies } from "./ManageJobFamilies/ManageJobFamilies";
import { ManagePathsGrades } from "./PathsGrades/ManagePathsGrades";
import { ManageSubgrades } from "./ManageSubgrades/ManageSubgrades";

type ManageInternalGradeProps = {
  configYear: number;
};

export const ManageInternalGrade = ({
  configYear,
}: ManageInternalGradeProps) => {
  const filters = [
    { value: InternalGradePagesEnum.JOB_FAMILIES, label: JOB_FAMILIES },
    { value: InternalGradePagesEnum.PATHS_GRADES, label: GRADES_PATHS },
    { value: InternalGradePagesEnum.SUBGRADES, label: SUBGRADES_LABEL },
  ];

  const [selectedFilter, setSelectedFilter] = useState<
    OptionItem<InternalGradePagesEnum>
  >(filters[0]);
  const [disableFilters, setDisableFilters] = useState(false);

  return (
    <StyledManagementPage>
      <StyledManagementHeader>
        <DoubleStructure verticalAlignment={AlignmentEnum.CENTER}>
          <TitlesTyp variant="2" fontWeight={FontWeightEnum.SEMIBOLD}>
            {INTERNAL_GRADE_LABEL}
          </TitlesTyp>
          <TextSwitch
            disabled={disableFilters}
            selectedOption={selectedFilter}
            setSelectedOption={setSelectedFilter}
            options={filters}
          />
        </DoubleStructure>
      </StyledManagementHeader>
      {selectedFilter.value === InternalGradePagesEnum.JOB_FAMILIES && (
        <ManageJobFamilies
          setDisableFilters={setDisableFilters}
          configYear={configYear}
        />
      )}
      {selectedFilter.value === InternalGradePagesEnum.PATHS_GRADES && (
        <ManagePathsGrades
          setDisableFilters={setDisableFilters}
          configYear={configYear}
        />
      )}
      {selectedFilter.value === InternalGradePagesEnum.SUBGRADES && (
        <ManageSubgrades
          setDisableFilters={setDisableFilters}
          configYear={configYear}
        />
      )}
    </StyledManagementPage>
  );
};
